/**
 * The Vertiv Config Team author label (#1599 Story 4.1, PRD FR-12).
 *
 * The ONE place a discussion surface composes an author name with
 * `CONFIG_TEAM_LABEL`, so the visible and spoken forms cannot drift apart and
 * no render site carries the literal. `on` is the wire bit; the server has
 * already zeroed it while `FEATURE_CONFIG_TEAM_IDENTITY` is off, so only
 * `=== true` labels (an absent key from an older server reads as false).
 *
 * The bubble's group label does NOT use `withConfigTeamLabel`: it renders the
 * name and `configTeamSuffix` as two Text nodes so the name can truncate and
 * the label never does (frame H1).
 */
import { CONFIG_TEAM_LABEL } from './correspondence.types';

/** The visible separator, its own Text in the bubble group label. */
export const configTeamSuffix = ` · ${CONFIG_TEAM_LABEL}`;

/** Visible form: `Name · Vertiv Config Team`, or the name alone. */
export const withConfigTeamLabel = (
  name: string,
  on: boolean | undefined,
): string => (on === true ? `${name}${configTeamSuffix}` : name);

/** Spoken form for accessibility labels: `Name, Vertiv Config Team`. */
export const spokenAuthor = (name: string, on: boolean | undefined): string =>
  on === true ? `${name}, ${CONFIG_TEAM_LABEL}` : name;
